import { render, staticRenderFns } from "./PortalMenu.vue?vue&type=template&id=5d245350&"
import script from "./PortalMenu.vue?vue&type=script&lang=ts&"
export * from "./PortalMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d245350')) {
      api.createRecord('5d245350', component.options)
    } else {
      api.reload('5d245350', component.options)
    }
    module.hot.accept("./PortalMenu.vue?vue&type=template&id=5d245350&", function () {
      api.rerender('5d245350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/PortalMenu.vue"
export default component.exports